import 'bootstrap/dist/css/bootstrap.min.css';
import { useEffect, useState } from 'react';
import axios from 'axios';
import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import CardApp from '../components/CardApp';

function AppsGetAll() {
    const [response, setResponse] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        const fetchResponse = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_URL}/site/apps`);
                setResponse(response.data || []);
            } catch (err) {
                setError('No se pudo cargar el contenido.');
                console.error(err);
            } finally {
                setLoading(false);
            }
        };

        fetchResponse();
    }, []);

    if (loading) {
        return (
            <div>
                <Container>Cargando...</Container>
            </div>
        );
    }

    if (error) {
        return (
            <div>
                <Container>{error}</Container>
            </div>
        );
    }

    return (
        <Row xs={2} md={4} className="g-4">
            {response.map((item, idx) => (
                <Col>
                    <CardApp
                        image={item.image}
                        name={item.name}
                        platforms={item.platforms}
                    />
                </Col>
            ))}
        </Row>
    );
}

export default AppsGetAll;